var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckPlate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13760_19394)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13760_19394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 18.375H18.25L16.9375 21.4375H11.25L10.8125 20.125L10.375 18.8125L9.5 18.375L8.625 17.9375H7.3125L6 18.8125L5.125 21.4375H2.5V15.3125L5.125 13.5625H9.0625L10.8125 12.6875V7.875H7.75L9.5 5.25H16.5V18.375Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.0791 14.9658V21.7209",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99515 23.4159C6.59559 23.4159 5.46101 22.2814 5.46101 20.8818C5.46101 19.4822 6.59559 18.3477 7.99515 18.3477C9.39472 18.3477 10.5293 19.4822 10.5293 20.8818C10.5293 22.2814 9.39472 23.4159 7.99515 23.4159Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07948 21.7207H5.60352",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3786 21.7207H17.4346",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46094 13.2793L2.07944 14.9661",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8868 23.4159C23.4872 23.4159 22.3526 22.2814 22.3526 20.8818C22.3526 19.4822 23.4872 18.3477 24.8868 18.3477C26.2863 18.3477 27.4209 19.4822 27.4209 20.8818C27.4209 22.2814 26.2863 23.4159 24.8868 23.4159Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8867 18.3477H16.4369",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8184 23.4159C18.4188 23.4159 17.2843 22.2814 17.2843 20.8818C17.2843 19.4822 18.4188 18.3477 19.8184 18.3477C21.218 18.3477 22.3525 19.4822 22.3525 20.8818C22.3525 22.2814 21.218 23.4159 19.8184 23.4159Z",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4365 4.8291H12.2156",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4365 18.3472V4.8291",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.925 8.21094H10.375",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.375 11.584C10.375 12.5184 9.62268 13.2708 8.68821 13.2708",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83496 13.2793H5.46139",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.375 11.5845V8.21094",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4597 13.2792L7.14648 8.21094",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14754 8.2106C8.83433 4.8291 9.41243 4.8291 12.2158 4.8291",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13760_19394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.75)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13760_19394"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 21.4667,
    fill: "white",
    transform: "matrix(-1 0 0 1 28.75 3.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckPlate);
export default __webpack_public_path__ + "static/media/truckPlate.8893ef81b21e4fc3b3c9948a6115a2f9.svg";
export { ForwardRef as ReactComponent };